import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter } from 'mdb-react-ui-kit';

const ControlInventario = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [inventory, setInventory] = useState([
    { id: 1, material: "Plástico", quantity: 100, movementType: "Entrada", date: "2023-11-01", provider: "Proveedor A", warehouse: "Bodega A" },
    { id: 2, material: "Vidrio", quantity: 50, movementType: "Salida", date: "2023-11-02", provider: "Proveedor B", warehouse: "Bodega B" },
    { id: 3, material: "Papel", quantity: 80, movementType: "Entrada", date: "2023-11-03", provider: "Proveedor C", warehouse: "Bodega C" },
    { id: 4, material: "Plástico", quantity: 40, movementType: "Salida", date: "2023-11-05", provider: "Proveedor A", warehouse: "Bodega A" },
  ]);
  const [selectedMovement, setSelectedMovement] = useState(null);
  const [filterText, setFilterText] = useState('');
  const [isDarkMode, setIsDarkMode] = useState(false);

  const providers = ["Proveedor A", "Proveedor B", "Proveedor C"];
  const materials = ["Plástico", "Vidrio", "Papel"];
  const warehouses = ["Bodega A", "Bodega B", "Bodega C"];

  const toggleModal = () => setModalOpen(!modalOpen);

  const handleAddEditMovement = () => {
    if (selectedMovement.id) {
      setInventory(prevInventory =>
        prevInventory.map(movement =>
          movement.id === selectedMovement.id ? selectedMovement : movement
        )
      );
    } else {
      const newMovement = { id: inventory.length + 1, ...selectedMovement };
      setInventory([...inventory, newMovement]);
    }
    toggleModal();
  };

  const openAddModal = () => {
    setSelectedMovement({ material: "", quantity: "", movementType: "", date: "", provider: "", warehouse: "" });
    toggleModal();
  };

  const materialTotals = inventory.reduce((acc, curr) => {
    if (!acc[curr.material]) {
      acc[curr.material] = { material: curr.material, entrada: 0, salida: 0, stock: 0, warehouse: curr.warehouse };
    }
    if (curr.movementType === "Entrada") {
      acc[curr.material].entrada += curr.quantity;
      acc[curr.material].stock += curr.quantity;
    } else if (curr.movementType === "Salida") {
      acc[curr.material].salida += curr.quantity;
      acc[curr.material].stock -= curr.quantity;
    }
    return acc;
  }, {});

  const totalData = Object.values(materialTotals);

  const columnsTotals = [
    { name: "Material", selector: row => row.material, sortable: true },
    { name: "Bodega", selector: row => row.warehouse, sortable: true },
    { name: "Total Entrada", selector: row => row.entrada, sortable: true },
    { name: "Total Salida", selector: row => row.salida, sortable: true },
    { name: "En Stock", selector: row => row.stock, sortable: true },
  ];

  const columnsMovements = [
    { name: "ID", selector: row => row.id, sortable: true, width: "70px" },
    { name: "Material", selector: row => row.material, sortable: true, grow: 2 },
    { name: "Bodega", selector: row => row.warehouse, sortable: true },
    { name: "Cantidad", selector: row => row.quantity, sortable: true },
    { name: "Tipo de Movimiento", selector: row => row.movementType, sortable: true },
    { name: "Fecha", selector: row => row.date, sortable: true },
    { name: "Proveedor", selector: row => row.provider, sortable: true },
  ];

  const filteredItems = inventory.filter(
    item => item.material.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <div className="container-fluid p-0">
      <h1 className="h3 mb-3">Control de Inventario</h1>
      <div className="card">
        <div className="card-body">
          {/* Tabla de Totales */}
          <DataTable
            title="Resumen de Materiales"
            columns={columnsTotals}
            data={totalData}
            pagination={false}
            fixedHeader
            fixedHeaderScrollHeight="300px"
            noDataComponent="No hay datos disponibles"
          />

          {/* Divisor */}
          <hr className="my-4" />

          {/* Filtro y botón */}
          <div className="row mb-3">
            <div className="col-md-6 col-xl-4 mb-2 mb-md-0">
              <input
                type="text"
                className="form-control"
                placeholder="Buscar por material…"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </div>
            <div className="col-md-6 col-xl-8 text-end">
              <button onClick={openAddModal} className="btn btn-primary">
                <i className="fas fa-plus-circle"></i> Nuevo Movimiento
              </button>
            </div>
          </div>

          {/* Tabla de Movimientos */}
          <DataTable
            title="Movimientos de Inventario"
            columns={columnsMovements}
            data={filteredItems}
            pagination
            fixedHeader
            fixedHeaderScrollHeight="450px"
            noDataComponent="No hay movimientos de inventario disponibles"
          />
        </div>
      </div>

      {/* Modal para agregar movimiento */}
      <MDBModal show={modalOpen} setShow={setModalOpen}>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>{selectedMovement?.id ? "Editar Movimiento" : "Nuevo Movimiento"}</MDBModalTitle>
              <button type="button" className="btn-close" onClick={toggleModal}></button>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <div className="mb-3">
                  <label className="form-label">Material</label>
                  <select
                    className="form-control"
                    value={selectedMovement?.material || ""}
                    onChange={(e) => setSelectedMovement({ ...selectedMovement, material: e.target.value })}
                  >
                    <option value="">Seleccione un material</option>
                    {materials.map((material, index) => (
                      <option key={index} value={material}>{material}</option>
                    ))}
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">Cantidad</label>
                  <input
                    type="number"
                    className="form-control"
                    value={selectedMovement?.quantity || ""}
                    onChange={(e) => setSelectedMovement({ ...selectedMovement, quantity: parseInt(e.target.value) || 0 })}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Tipo de Movimiento</label>
                  <select
                    className="form-control"
                    value={selectedMovement?.movementType || ""}
                    onChange={(e) => setSelectedMovement({ ...selectedMovement, movementType: e.target.value })}
                  >
                    <option value="">Seleccione</option>
                    <option value="Entrada">Entrada</option>
                    <option value="Salida">Salida</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">Bodega</label>
                  <select
                    className="form-control"
                    value={selectedMovement?.warehouse || ""}
                    onChange={(e) => setSelectedMovement({ ...selectedMovement, warehouse: e.target.value })}
                  >
                    <option value="">Seleccione una bodega</option>
                    {warehouses.map((warehouse, index) => (
                      <option key={index} value={warehouse}>{warehouse}</option>
                    ))}
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">Fecha</label>
                  <input
                    type="date"
                    className="form-control"
                    value={selectedMovement?.date || ""}
                    onChange={(e) => setSelectedMovement({ ...selectedMovement, date: e.target.value })}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Proveedor</label>
                  <select
                    className="form-control"
                    value={selectedMovement?.provider || ""}
                    onChange={(e) => setSelectedMovement({ ...selectedMovement, provider: e.target.value })}
                  >
                    <option value="">Seleccione un proveedor</option>
                    {providers.map((provider, index) => (
                      <option key={index} value={provider}>{provider}</option>
                    ))}
                  </select>
                </div>
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <button type="button" className="btn btn-primary" onClick={handleAddEditMovement}>Guardar</button>
              <button type="button" className="btn btn-secondary" onClick={toggleModal}>Cancelar</button>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </div>
  );
};

export default ControlInventario;
